import Title from '@cohort/components-xps/components/Title';
import {classNames} from '@cohort/shared-frontend/utils/classNames';
import {
  getAppFromTriggerIntegration,
  getDetailsComponentFromTriggerIntegration,
} from '@cohort/wallet/apps/TriggerIntegration';
import SecondaryButton from '@cohort/wallet/components/button/SecondaryButton';
import BaseModal from '@cohort/wallet/components/modals/BaseModal';
import DrawerModal from '@cohort/wallet/components/modals/DrawerModal';
import useScreenSizeContext from '@cohort/wallet/hooks/useScreenSize';
import type {JourneyStepTriggerWDto} from '@cohort/wallet-schemas/journeySteps';
import {Eye} from '@phosphor-icons/react';
import React, {Fragment} from 'react';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

type DetailsComponentWrapperProps = {
  trigger: JourneyStepTriggerWDto;
};

const DetailsComponentWrapper: React.FC<DetailsComponentWrapperProps> = ({trigger}) => {
  const {t} = useTranslation('pages', {keyPrefix: 'space.journeyDetailModal'});
  const {isMobile} = useScreenSizeContext();
  const [triggerModalOpen, setTriggerModalOpen] = useState(false);

  const app = getAppFromTriggerIntegration(trigger.triggerIntegrationId);
  const DetailsComponent = getDetailsComponentFromTriggerIntegration(trigger);
  const ModalComponent = isMobile ? DrawerModal : BaseModal;

  if (DetailsComponent === null) {
    return <Fragment />;
  }

  return (
    <div>
      <div className="mt-3 flex items-center justify-center gap-2 md:mt-0 md:justify-start">
        <SecondaryButton
          className={classNames(isMobile ? 'w-full' : '!bg-transparent !p-0 underline')}
          size="small"
          onClick={() => setTriggerModalOpen(true)}
          text={
            <div className="flex items-center gap-3">
              <Eye className="h-4 w-4" />
              {t('triggerModalCtaTitle')}
            </div>
          }
          tracking={{
            namespace: 'journeys.detail.triggerModalCta',
            metadata: undefined,
          }}
        />
      </div>

      {triggerModalOpen && (
        <ModalComponent
          title={
            <div className="flex w-full content-between">
              <Title content={trigger.title} classes="text-2xl font-semibold" />
              {app.logo !== null && (
                <div className="flex w-20 flex-col items-center space-y-2">
                  {React.cloneElement(app.logo, {height: 32, width: 32})}
                  <p className="text-center text-sm font-medium">{app.spec.name}</p>
                </div>
              )}
            </div>
          }
          tracking={{namespace: 'modals.journeys.triggers.details'}}
          onClose={() => setTriggerModalOpen(false)}
        >
          <DetailsComponent config={trigger.triggerIntegrationConfig} />
        </ModalComponent>
      )}
    </div>
  );
};

export default DetailsComponentWrapper;
